export default {
    "$id": "https://integration.cloud.tibco.com/schemas/ng-customization.schema.json",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "description": "JSON schema for TCI web server tenant customization.",
    "type": "object",
    "patternProperties": {
        "^(APP_CREATE|GLOBAL_NAVBAR|HELP_PANEL|DOCUMENT_TITLE|APP_MAIN_MENU_EXTENSIONS|APP_MAIN_MENU_ENV_TOOLS|APP_LIST_ROW_HAMBURGER|APP_LIST_HEADER_MONITORING|APP_LIST_FILTERS|APP_LIST_COL_CATEGORY|APP_LIST_COL_DEPLOYMENT|APP_LIST_COL_INSTANCES|APP_LIST_COL_LAST_RUN|APP_LIST_COL_STATUS|CONNECTIONS_LIST_FILTER|CONNECTIONS_LIST_COL_CATEGORY|CONNECTIONS_LIST_COL_VISIBILITY|CONNECTIONS_LIST_ROW_HAMBURGER|MARKETPLACE_LIST_FILTER|APP_DETAIL_HEADER_CATEGORY|APP_DETAIL_HEADER_CREATED_BY|APP_LIST_PEEK_VIEW|APP_LIST_COL_WIDTH|APP_MAIN_MENU_MARKETPLACE|TCI_SCRIPTS_GOOGLE|TCI_SCRIPTS_PENDO|APP_LIST_FILTER_TAGS|APP_DETAIL_HEADER_TAGS|APP_LIST_FILTERS_APP_CATEGORY|APP_LIST_FILTERS_APP_OWNER|APP_LIST_FILTERS_DEPLOY_CATEGORY)$": {
            "$ref": "#/definitions/custom-point"
        }
    },
    "additionalProperties": false,
    "definitions": {
        "custom-point": {
            "type": "object",
            "required": [
                "enabled"
            ],
            "properties": {
                "enabled": {
                    "type": "boolean",
                    "description": "Whether the custom point is enabled or not."
                },
                "imageUrl": {
                    "type": "string",
                    "description": ""
                },
                "styleCss": {
                    "type": "string",
                    "description": ""
                },
                "tenantCustomization": {
                    "type": "boolean",
                    "description": ""
                },
                "visible": {
                    "type": "boolean",
                    "description": ""
                },
                "label": {
                    "type": "string",
                    "description": ""
                }
            }
        }
    }
};
